export default __webpack_public_path__ + "static/media/v3ex7-min.e490dda6.png";